/**
 * One abort token for object-selection resolution on both canvas left-click
 * and right-click. The two handlers are separate hook instances, so a React
 * `useAbortController` in either one cannot cancel the other.
 */
let controller = new AbortController();

/** Abort any in-flight resolve and return the signal for the new attempt. */
export function abortSharedSelection(): AbortSignal {
    controller.abort();
    controller = new AbortController();
    return controller.signal;
}

export function getSharedSelectionSignal(): AbortSignal {
    return controller.signal;
}

/** Test-only: drop any leftover aborted signal from a previous case. */
export function resetSharedSelectionAbort(): void {
    controller = new AbortController();
}
